var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 180 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4f46e5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 8,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 18,
    width: 8,
    height: 26,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8,
    width: 8,
    height: 36,
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 24,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 24 L20 14 L32 4",
    stroke: "#4f46e5",
    strokeWidth: 2,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1f2937"
  }, /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 34,
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: -0.5
  }, "\n      DATA LAB\n    "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5fe1dc37af79164f1a669faf2a8ac89c.svg";
export { ForwardRef as ReactComponent };